export default __webpack_public_path__ + "b25572abe0d96e36ee1b26c5b1d2d1fb.jpg";